import { sortList } from '@/data/selector/sortList'
import { SortObject } from '@/data/@types/SortObject'

export const queryConvertToSortKeyAndOrder = (sortKey: string): SortObject => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const defaultSortObject = sortList.find(e => e.value === 'SCORE')!
  const sortObject = sortList.find(e => e.value === sortKey)
  return sortObject || defaultSortObject
}
